import { AccordionContainer } from "@app/shared";
import { memo } from "react";
import { useImportConfig } from "../hooks";
import { ProviderNetworkImportGridGroup } from "./ProviderNetworkImportGridGroup";

function nonMemoProviderNetworkImportGrid() {
  const { getConfiguredGroups } = useImportConfig();

  const importConfigGroups = getConfiguredGroups().map((group) => {
    return (<ProviderNetworkImportGridGroup key={group} group={group} />);
  });

  return (
    <div className="pt-2">
      <AccordionContainer>{importConfigGroups}</AccordionContainer>
    </div>
  );
}

export const ProviderNetworkImportGrid = memo(nonMemoProviderNetworkImportGrid);
